import type { StreamChat, Channel, DefaultGenerics } from 'stream-chat'

import { logger } from 'src/lib/logger'

export const getChannels = async (
  client: StreamChat | null,
  currentUserId: string,
  otherUserId: string,
): Promise<Channel<DefaultGenerics>[] | null> => {
  if (!client) {
    return null
  }

  if (!client.userID) {
    return null
  }

  try {
    const channels = await client.queryChannels({
      members: { $eq: [currentUserId, otherUserId].sort() },
      type: { $eq: 'network' },
    })

    if (channels && channels.length > 0) {
      return channels
    }

    return null
  } catch (error) {
    logger.error('💥 Error fetching channels:', error)
    return null
  }
}
